export default __webpack_public_path__ + "static/media/closet5-after3.2a36af66.jpg";